import api from './api';

const patientService = {
    getAll: async (params) => {
        const response = await api.get('/patients', { params });
        return response.data;
    },

    getOne: async (id) => {
        const response = await api.get(`/patients/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await api.post('/patients', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/patients/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/patients/${id}`);
        return response.data;
    },

    getStats: async () => {
        const response = await api.get('/patients/stats');
        return response.data;
    },

    getTreatments: async (patientId) => {
        const response = await api.get(`/treatments`, { params: { patientId } });
        return response.data;
    },

    getPrescriptions: async (patientId) => {
        const response = await api.get(`/prescriptions`, { params: { patientId } });
        return response.data;
    },

    createTreatment: async (data) => {
        const response = await api.post('/treatments', data);
        return response.data;
    },

    updateTreatment: async (id, data) => {
        const response = await api.put(`/treatments/${id}`, data);
        return response.data;
    },

    deleteTreatment: async (id) => {
        const response = await api.delete(`/treatments/${id}`);
        return response.data;
    },

    createPrescription: async (data) => {
        const response = await api.post('/prescriptions', data);
        return response.data;
    },

    updatePrescription: async (id, data) => {
        const response = await api.put(`/prescriptions/${id}`, data);
        return response.data;
    },

    deletePrescription: async (id) => {
        const response = await api.delete(`/prescriptions/${id}`);
        return response.data;
    }
};

const dentistService = {
    getAll: async (params) => {
        const response = await api.get('/dentists', { params });
        return response.data;
    },

    getOne: async (id) => {
        const response = await api.get(`/dentists/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await api.post('/dentists', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/dentists/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/dentists/${id}`);
        return response.data;
    }
};

const appointmentService = {
    getAll: async (params) => {
        const response = await api.get('/appointments', { params });
        return response.data;
    },

    getToday: async () => {
        const response = await api.get('/appointments/today');
        return response.data;
    },

    getOne: async (id) => {
        const response = await api.get(`/appointments/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await api.post('/appointments', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/appointments/${id}`, data);
        return response.data;
    },

    cancel: async (id, reason) => {
        const response = await api.put(`/appointments/${id}/cancel`, { reason });
        return response.data;
    }
};

const treatmentService = {
    getAll: async (params) => {
        const response = await api.get('/treatments', { params });
        return response.data;
    },

    getOne: async (id) => {
        const response = await api.get(`/treatments/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await api.post('/treatments', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/treatments/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/treatments/${id}`);
        return response.data;
    }
};

const prescriptionService = {
    getAll: async (params) => {
        const response = await api.get('/prescriptions', { params });
        return response.data;
    },

    getOne: async (id) => {
        const response = await api.get(`/prescriptions/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await api.post('/prescriptions', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/prescriptions/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/prescriptions/${id}`);
        return response.data;
    }
};

const paymentService = {
    getAll: async (params) => {
        const response = await api.get('/payments', { params });
        return response.data;
    },

    getOne: async (id) => {
        const response = await api.get(`/payments/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await api.post('/payments', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/payments/${id}`, data);
        return response.data;
    },

    recordPayment: async (id, data) => {
        const response = await api.put(`/payments/${id}/record-payment`, data);
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/payments/${id}`);
        return response.data;
    },

    getStats: async () => {
        const response = await api.get('/payments/stats');
        return response.data;
    }
};

const clinicService = {
    getProfile: async () => {
        const response = await api.get('/clinic/profile');
        return response.data;
    },

    getSubscription: async () => {
        const response = await api.get('/clinic/subscription');
        return response.data;
    },

    updateProfile: async (data) => {
        const response = await api.put('/clinic/profile', data);
        return response.data;
    },

    updateSettings: async (settings) => {
        const response = await api.put('/clinic/settings', { settings });
        return response.data;
    },

    getUsers: async () => {
        const response = await api.get('/clinic/users');
        return response.data;
    },

    createUser: async (data) => {
        const response = await api.post('/clinic/users', data);
        return response.data;
    },

    updateUser: async (id, data) => {
        const response = await api.put(`/clinic/users/${id}`, data);
        return response.data;
    },

    deactivateUser: async (id) => {
        const response = await api.delete(`/clinic/users/${id}`);
        return response.data;
    }
};

const dashboardService = {
    getStats: async () => {
        const response = await api.get('/dashboard/stats');
        return response.data;
    },

    getCalendar: async (startDate, endDate) => {
        const response = await api.get('/dashboard/calendar', {
            params: { startDate, endDate }
        });
        return response.data;
    }
};

const uploadService = {
    uploadLogo: async (file) => {
        const formData = new FormData();
        formData.append('logo', file);
        const response = await api.post('/upload/logo', formData, {
            headers: { 'Content-Type': undefined }
        });
        return response.data;
    },

    uploadSignature: async (file) => {
        const formData = new FormData();
        formData.append('digitalSignature', file);
        const response = await api.post('/upload/signature', formData, {
            headers: { 'Content-Type': undefined }
        });
        return response.data;
    },

    uploadProfile: async (file) => {
        const formData = new FormData();
        formData.append('profilePicture', file);
        const response = await api.post('/upload/profile', formData, {
            headers: { 'Content-Type': undefined }
        });
        return response.data;
    }
};

const userService = {
    getLanguage: async () => {
        const response = await api.get('/user/language');
        return response.data;
    },

    updateLanguage: async (language) => {
        const response = await api.put('/user/language', { language });
        return response.data;
    },

    getProfile: async () => {
        const response = await api.get('/user/profile');
        return response.data;
    },

    updateProfile: async (data) => {
        const response = await api.put('/user/profile', data);
        return response.data;
    }
};

const toothHistoryService = {
    getDentalChart: async (patientId) => {
        const response = await api.get(`/tooth-history/patient/${patientId}`);
        return response.data;
    },

    getToothHistory: async (patientId, toothNumber) => {
        const response = await api.get(`/tooth-history/patient/${patientId}/tooth/${toothNumber}`);
        return response.data;
    },

    updateToothHistory: async (patientId, toothNumber, data) => {
        const response = await api.put(`/tooth-history/patient/${patientId}/tooth/${toothNumber}`, data);
        return response.data;
    },

    bulkUpdateToothHistory: async (data) => {
        const response = await api.post('/tooth-history/bulk-update', data);
        return response.data;
    }
};

const reportService = {
    getDentistReport: async (params) => {
        const response = await api.get('/reports/dentist', { params });
        return response.data;
    },

    getClinicReport: async (params) => {
        const response = await api.get('/reports/clinic', { params });
        return response.data;
    },

    getAnalytics: async (params) => {
        const response = await api.get('/reports/analytics', { params });
        return response.data;
    }
};

const superAdminService = {
    createClinic: async (data) => {
        const response = await api.post('/superadmin/clinics', data);
        return response.data;
    },

    getAllClinics: async (params) => {
        const response = await api.get('/superadmin/clinics', { params });
        return response.data;
    },

    getClinic: async (id) => {
        const response = await api.get(`/superadmin/clinics/${id}`);
        return response.data;
    },

    updateClinic: async (id, data) => {
        const response = await api.put(`/superadmin/clinics/${id}`, data);
        return response.data;
    },

    deleteClinic: async (id) => {
        const response = await api.delete(`/superadmin/clinics/${id}`);
        return response.data;
    },

    updateClinicStatus: async (id, status) => {
        const response = await api.patch(`/superadmin/clinics/${id}/status`, { status });
        return response.data;
    },

    extendSubscription: async (id, days, amount) => {
        const response = await api.post(`/superadmin/clinics/${id}/extend`, { days, amount });
        return response.data;
    },

    updateDentistLimit: async (id, dentistLimit) => {
        const response = await api.patch(`/superadmin/clinics/${id}/dentist-limit`, { dentistLimit });
        return response.data;
    },

    getStatistics: async () => {
        const response = await api.get('/superadmin/statistics');
        return response.data;
    }
};

const expenseService = {
    getAll: async (params) => {
        const response = await api.get('/expenses', { params });
        return response.data;
    },

    getOne: async (id) => {
        const response = await api.get(`/expenses/${id}`);
        return response.data;
    },

    create: async (data) => {
        const response = await api.post('/expenses', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/expenses/${id}`, data);
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/expenses/${id}`);
        return response.data;
    },

    getStats: async (params) => {
        const response = await api.get('/expenses/stats', { params });
        return response.data;
    }
};

const notificationService = {
    getAll: async (params) => {
        const response = await api.get('/notifications', { params });
        return response.data;
    },

    getToday: async () => {
        const response = await api.get('/notifications/today');
        return response.data;
    },

    getUnreadCount: async () => {
        const response = await api.get('/notifications/count/unread');
        return response.data;
    },

    create: async (data) => {
        const response = await api.post('/notifications', data);
        return response.data;
    },

    update: async (id, data) => {
        const response = await api.put(`/notifications/${id}`, data);
        return response.data;
    },

    markAsRead: async (id) => {
        const response = await api.put(`/notifications/${id}/mark-read`);
        return response.data;
    },

    complete: async (id) => {
        const response = await api.put(`/notifications/${id}/complete`);
        return response.data;
    },

    delete: async (id) => {
        const response = await api.delete(`/notifications/${id}`);
        return response.data;
    }
};

export {
    patientService,
    dentistService,
    appointmentService,
    treatmentService,
    prescriptionService,
    paymentService,
    clinicService,
    dashboardService,
    uploadService,
    userService,
    toothHistoryService,
    reportService,
    superAdminService,
    expenseService,
    notificationService
};
